// Regalos automáticos en el carrito (Luis, 01/10). Ver snippets/la-regalos.liquid.
// Cada vez que cambia el carrito: tantos regalos como packs que los dan; si se quita el pack, se quita el regalo.
import { CartUpdateEvent } from '@theme/events';

const MAPA = window.laRegalos || {};
const MARCA = '_regalo';
let ocupado = false;
let pendiente = null;

const rutas = () => window.Shopify?.routes?.root || '/';
const pedir = (url, cuerpo) =>
  fetch(rutas() + url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-LA-Regalo': '1' },
    body: JSON.stringify(cuerpo),
  }).then((r) => r.json());

async function sincronizar() {
  if (ocupado || !Object.keys(MAPA).length) return;
  ocupado = true;
  try {
    const carrito = await fetch(rutas() + 'cart.js', { headers: { 'X-LA-Regalo': '1' } }).then((r) => r.json());
    const quiero = {};
    for (const it of carrito.items) {
      if (it.properties && it.properties[MARCA]) continue;
      for (const g of MAPA[String(it.variant_id)] || []) quiero[g] = (quiero[g] || 0) + it.quantity;
    }
    const regalos = carrito.items.filter((it) => it.properties && it.properties[MARCA]);
    let cambiado = false;
    for (const it of regalos) {
      const n = quiero[it.variant_id] || 0;
      if (it.quantity !== n) {
        await pedir('cart/change.js', { id: it.key, quantity: n });
        cambiado = true;
      }
      delete quiero[it.variant_id];
    }
    for (const [g, n] of Object.entries(quiero)) {
      if (n > 0) {
        await pedir('cart/add.js', { items: [{ id: Number(g), quantity: n, properties: { [MARCA]: 'Regalo del pack' } }] });
        cambiado = true;
      }
    }
    if (cambiado) {
      const nuevo = await fetch(rutas() + 'cart.js', { headers: { 'X-LA-Regalo': '1' } }).then((r) => r.json());
      document.dispatchEvent(new CartUpdateEvent(nuevo, 'la-regalos', { itemCount: nuevo.item_count, source: 'la-regalos' }));
    }
  } catch (e) {
    console.warn('[la-regalos]', e);
  } finally {
    ocupado = false;
  }
}

const programar = () => {
  clearTimeout(pendiente);
  pendiente = setTimeout(sincronizar, 250);
};

// Se engancha a cualquier cambio del carrito que haga el tema (añadir, cambiar cantidad, quitar, vaciar).
const fetchOriginal = window.fetch.bind(window);
window.fetch = async (recurso, opciones = {}) => {
  const resp = await fetchOriginal(recurso, opciones);
  try {
    const url = typeof recurso === 'string' ? recurso : recurso?.url || '';
    const cab = new Headers(opciones.headers || (recurso instanceof Request ? recurso.headers : undefined));
    if (/\/cart\/(add|change|update|clear)/.test(url) && !cab.get('X-LA-Regalo')) resp.clone().text().then(programar, programar);
  } catch {}
  return resp;
};
document.addEventListener('cart:update', (e) => { if (e.detail?.sourceId !== 'la-regalos') programar(); });
programar();
